import { useContext } from 'react';
import ApiContext from 'api/ApiContext';
import { useQuery } from 'react-query';

const useGetNationalData = (
  date: string,
  index: number,
  isNational: boolean,
  isFinal: boolean,
) => {
  const { getOpendataOverview } = useContext(ApiContext);
  // get all Abstimmungen of all time, grouped by date. No result info in this data
  const { data: dataByDate } = useQuery(['opendataOverview'], getOpendataOverview, {
    refetchInterval: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: isNational && isFinal,
  });

  const allOpendataPolls = dataByDate?.result?.resources;
  const formattedDate = date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1');
  const currentPoll = allOpendataPolls?.find(
    ({ coverage }) => coverage === formattedDate,
  );

  const { getOpendataPollDay } = useContext(ApiContext);

  const url = currentPoll?.url;

  const { data } = useQuery(['opendataPoll', url], () => getOpendataPollDay(url), {
    refetchInterval: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: Boolean(url),
  });

  if (!isNational)
    return {
      nationalResults: undefined,
      nationalEligibleVoters: undefined,
      nationalParticipation: undefined,
    };

  const vorlage = data?.schweiz?.vorlagen?.at(index - 1);
  const isNationalFinal = vorlage?.resultat?.gebietAusgezaehlt;

  if (!isNationalFinal) {
    return {
      nationalResults: null,
      nationalEligibleVoters: null,
      nationalParticipation: null,
    };
  }

  const yesPercentage = vorlage?.resultat.jaStimmenInProzent;
  const noPercentage = vorlage && 100 - vorlage.resultat.jaStimmenInProzent;
  const yesAbsolute = vorlage?.resultat.jaStimmenAbsolut;
  const noAbsolute = vorlage?.resultat.neinStimmenAbsolut;
  const participation = vorlage?.resultat.stimmbeteiligungInProzent;
  const eligibleVoters = vorlage?.resultat.anzahlStimmberechtigte;

  return {
    nationalResults: {
      yes_votes: yesAbsolute,
      yes_votes_percentage: yesPercentage,
      no_votes: noAbsolute,
      no_votes_percentage: noPercentage,
      blank_votes: null,
      blank_votes_percentage: null,
      poll_result: null,
    },
    nationalEligibleVoters: eligibleVoters,
    nationalParticipation: participation,
  };
};

export default useGetNationalData;
